<template>
  <v-card flat class="settings-card">
    <v-container>
      <v-card-title class="settings-header-text mb-smAndDown-0 pb-smAndDown-0">List Types</v-card-title>
      <v-data-table :headers="headers" :items="listTypes" class="elevation-0">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <!-- <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  @click="onEditDialogOpen"
                  dark
                  class="mb-2"
                  v-on="on"
                  >New List</v-btn
                >
              </template> -->
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} List</span>
                  <v-spacer></v-spacer>
                  <v-btn text icon color="grey" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      v-model="formValid"
                      @submit.prevent="onSave"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            autofocus
                            v-model="editedItem.name"
                            required
                            :rules="[rules.required]"
                            label="Name"
                            placeholder="Name"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="onSave">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.system="{ item }">
          {{ item.system ? "System" : "Custom" }}
        </template>
        <template v-slot:item.count="{ item }">
          {{ item.items.length }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small @click="onPopListItems(item)" v-on="on">
                <v-icon small>mdi-format-list-numbered</v-icon>
              </v-btn>
            </template>
            <span>Manage {{ item.name }}s</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                @click="onEditItem(item)"
                v-if="!item.system"
                v-on="on"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit List</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                @click="onDeleteItem(item)"
                v-if="!item.system"
                v-on="on"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete List</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog v-model="listDialog" max-width="800px">
        <v-card-title class="dialog-background">
          <span class="headline mt-2 ml-3">{{
            selectedListType ? selectedListType.name : "Manage Items"
          }}</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onCloseManageItems">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container v-if="selectedListTypeId > 0" class="dialog-background">
          <list-type-fields :listTypeId="selectedListTypeId"></list-type-fields>
        </v-container>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import ListType from "../../models/ListType";
import ListTypeFields from "./fields/ListTypeFields";

export default {
  name: "ListSettings",
  components: {
    ListTypeFields
  },
  directives: {},
  data: function() {
    return {
      selectedListTypeId: null,
      dialog: false,
      listDialog: false,
      formValid: true,
      editedIndex: -1,
      editedItem: new ListType(),

      rules: {
        required: value => !!value || "Required"
      }
    };
  },
  created() {
    this.$store.dispatch("entities/listTypes/hydrate", 0);
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: true
        },
        { text: "Type", value: "system", sortable: true },
        { text: "Items", value: "count", sortable: true },
        { text: "Action", align: "right", value: "actions", sortable: false }
      ];
      return headers;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    listTypes() {
      let listTypes = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("system", true) // TODO remove when adding custom lists
        .orderBy("text")
        .get();
      return listTypes.sort((a, b) => a.name.localeCompare(b.name));
    },
    selectedListType() {
      const vueThis = this;
      const listType = this.listTypes.filter(val => {
        return val.id == vueThis.selectedListTypeId;
      });
      if (listType) {
        return listType[0];
      } 
      return null;
    }
  },
  methods: {
    onCloseManageItems() {
      this.listDialog = false;
    },
    onEditItem(item) {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.editedIndex = this.listTypes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onPopListItems(item) {
      this.listDialog = true;
      this.selectedListTypeId = item.id;
    },
    onDeleteItem(item) {
      if (confirm("Are you sure you want to delete this list?")) {
        item.isDirty = true;
        this.$store.dispatch("entities/listTypes/deleteListType", item);
      }
    },
    onEditDialogOpen() {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onClose() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, new ListType());
        this.editedIndex = -1;
      }, 300);
    },
    onSave() {
      if (this.$refs.form.validate()) {
        let vueThis = this;
        // Add New
        if (!(this.editedItem && this.editedItem.id)) {
          this.editedItem.isDirty = true;
          this.editedItem.listTypeId = this.listTypeId;
          this.editedItem.rank = this.listTypes.length;
          vueThis.$store.dispatch(
            "entities/listTypes/createListType",
            vueThis.editedItem
          );
          // Edit
        } else if (this.editedItem) {
          vueThis.$store.dispatch(
            "entities/listTypes/updateListType",
            vueThis.editedItem
          );
        }
        this.onClose();
      }
    }
  },
  watch: {}
};
</script>

<style scoped lang="stylus">
div.dialog-background {
  background-color: white;
}
</style>
